import axios from 'axios';
import { groupBy, mergeArrsByKey } from '@/helpers';

import { httpWithLoader } from '@/http-common';

const state = () => ({
    user: {}, // Информация о пользователе
    users: [], // Список пользователей
    roles: [], // Список ролей
});

const getters = {};

const mutations = {
    // Изменение информации о юзере
    SET_USER(state, user) {
        state.user = Object.assign(state.user, user)
    },
    SET_USERS(state, users) {
        state.users = users
    },
    SET_ROLES(state, roles) {
        state.roles = roles
    },
    ADD_USERS(state, user) {
        state.users.push(user)
    },
    UPDATE_USERS(state, updatedUser) {
        state.users = state.users.map(user => user.id === updatedUser.id ? updatedUser : user)
    },
    DELETE_USERS(state, userId) {
        state.users = state.users.filter(el => el.id !== userId)
    },
    CHANGE_AVATAR(state, avatar) {
        state.user.avatar = avatar.link
    }
};

const handleError = ((error, commit) => {
    commit('common/TOGGLE_ALERT', { open: true, status: 'error', text: `Что то пошло не так, пожалуйста перезагрузите страницу и попробуйте ещё раз` }, { root: true })
    console.log(`url: ${ error.config ? error.config.url : '-' }\nmethod: ${ error.config ? error.config.method : '-' }\npayload: ${ error.config ? error.config.data : '-' }`);

    if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        const tempMessage = error.response.data.trace.map(el => el.file).join('\n')
        console.log(`message: ${error.response.data.message}\nfiles:\n${tempMessage}`);
    } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the 
        // browser and an instance of
        // httpWithLoader.ClientRequest in node.js
        console.log(error.request);
    } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Ошибка', error.message);
    }
});

const actions = {
    // Получить информацию о пользователе
    async LOAD_USER({ commit, rootState }) {
        await httpWithLoader.get(`/auth/me`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_USER', response.data)
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },
    
    // Изменить информацию о пользователе
    async UPDATE_USER({ commit, rootState }, data) {
        await httpWithLoader.put(`/auth/edit`, data, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_USER', response.data)
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },
    
    // Изменить конкретного пользователя
    async UPDATE_CURRENT_USER({ commit, rootState }, { userId, params }) {
        return await httpWithLoader.put(`/user/${ userId }`, params, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('UPDATE_USERS', response.data)

            return response.status
        })
        .catch((reject) => {
            handleError(reject, commit)

            return reject.response.status
        });
    },
    
    // Получить список пользователей
    async LOAD_USERS({ commit, rootState }, data) {
        return await httpWithLoader.get(`/user`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_USERS', response.data)
            
            return response.status
        })
        .catch((reject) => {
            handleError(reject, commit)

            return reject.response.status
        });
    },

    // Создать пользователя
    async CREATE_USER({ commit, rootState }, data) {
        return await httpWithLoader.post(`/user`, data, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('ADD_USERS', response.data)

            return response.status
        })
        .catch((reject) => {
            handleError(reject, commit)

            return reject.response.status
        });
    },

    // Создать пользователя
    async SAVE_USER_IMAGE({ commit, rootState }, { userId, data}) {
        await httpWithLoader.post(`/user/${userId}/image`, data, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('CHANGE_AVATAR', response.data)
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    // Создать пользователя
    async DELETE_USERS({ commit, rootState }, userId) {
        await httpWithLoader.delete(`/user/${userId}`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('DELETE_USERS', userId)
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    // Получить список ролей
    async LOAD_ROLES({ commit, rootState }, data) {
        await httpWithLoader.get(`/user/roles`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_ROLES', response.data)
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
